<template>
  <div>
    <vs-card>
      <div slot="header">
        <h3>Filtrele</h3>
      </div>
      <vs-divider />
      <div>
        <b-row align-v="center">
          <b-col lg="2" sm="5">
            <b-form-input
              v-model="stKodBas"
              id="smallInput"
              placeholder="Stok Kodu"
            />
          </b-col>
          <b-col lg="2" sm="5">
            <b-form-input
              v-model="stKodBit"
              id="smallInput"
              placeholder="Stok Kodu"
            />
          </b-col>
          <b-col lg="2" sm="5">
            <b-form-input
              v-model="arananDeger"
              @keyup.enter="stokList"
              id="smallInput"
              placeholder="Arama..."
            />
          </b-col>
          <b-col lg="2" sm="5" align-v="center" align-self="center">
            <b-row>
              <b-col lg="3">
                <vs-switch
                  style="border-radius: 25px"
                  v-model="bakiyesiOlanlar"
                  @change="stokList()"
                  vs-icon="done"
                />
              </b-col>
              <b-col> Bakiyesi Olanlar </b-col>
            </b-row>
          </b-col>
          <b-col lg="2" sm="5" align-v="center" align-self="center">
            <b-row>
              <b-col lg="3">
                <vs-switch
                  style="border-radius: 25px"
                  v-model="siparisiOlanlar"
                  @change="stokList()"
                  vs-icon="done"
                />
              </b-col>

              <b-col> Siparişi Olanlar </b-col>
            </b-row>
          </b-col>
          <b-col lg="2" sm="5">
            <vs-button
              style="border-radius: 5px; width: 100%"
              type="gradient"
              @click="stokList"
              id="button-with-loading-yeni"
              class="vs-con-loading__container"
              >Listele</vs-button
            >
          </b-col>
        </b-row>
      </div>
    </vs-card>
    <vs-card>
      <b-row>
        <b-col>
          <vs-button
            style="border-radius: 5px; font-size: 10px"
            color="#02a66d"
            gradient-color-secondary="rgb(1, 52, 74)"
            @click="resetState()"
            size="small"
            >Filtrelemeyi Resetle</vs-button
          >
        </b-col>
      </b-row>
      <ag-grid-vue
        style="width: 100%; height: 450px; margin-top: 25px"
        class="ag-theme-alpine"
        :defaultColDef="defaultColDef"
        :columnDefs="columnDefs"
        :rowData="rowData"
        :rowSelection="rowSelection"
        :localeText="localeText"
        @grid-ready="onGridReady"
        @rowClicked="onSelectionChanged"
        @first-data-rendered="onFirstDataRendered"
        @filter-changed="onFilterChanged"
        @filter-modified="onFilterModified"
      >
      </ag-grid-vue>
      <div class="d-flex justify-content-between flex-wrap">
        <div class="d-flex align-items-center mb-0 mt-1">
          <span class="text-nowrap">{{ toplamKayitSayisi }} kayıt arasından gösterilen kayıt </span>
          <b-form-select
            v-model="pageLength"
            :options="['50', '100', '250', '500', '1000']"
            class="mx-1"
            v-on:change="stokList()"
          />
        </div>
        <div>
          <b-pagination
            :value="1"
            :total-rows="KAYITSAYISI"
            :per-page="pageLength"
            first-number
            last-number
            align="right"
            prev-class="prev-item"
            next-class="next-item"
            class="mt-1 mb-0"
            v-model="currentGelenPage"
            @input="stokList()"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </div>
      </div>
    </vs-card>
  </div>
</template>
<script>
import Store from "../../store/store";
import state from "../../store/state";
import moment from "moment";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import StokDetayButon from "../components/crm-components/stok-components/StokDetayButon.vue";
import ButtonPrimary from "../components/crm-components/global-components/ButtonPrimary.vue";

export default {
  data() {
    return {
      toplamKayitSayisi: 0,
      listsize: "",
      listtitle: "Listele",
      bakiyesiOlanlar: false,
      siparisiOlanlar: false,
      stKodBas: "",
      stKodBit: "",
      arananDeger: "",
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      rowSelection: null,

      localeText: null,
      columnDefs: null,
      rowData: null,
      pageLength: 50,
      currentGelenPage: 1,
      KAYITSAYISI: 0,
      gelenfiltre: "",
    };
  },
  methods: {
    resetState() {
      this.gridApi.setFilterModel(null);
      this.stokList();
    },

    onFilterChanged(e) {
      var savedFilterModel = e.api.getFilterModel();
      var keys = Object.keys(savedFilterModel);

      if (keys.length > 1) {
        console.log("arama yapma");
      } else {
        var vm = this;
        const soap = require("soap");
        const url = state.sistemAddress;
        if (vm.gelenfiltre == "") {
          vm.stokList();
        } else {
          var bstkod = vm.stKodBas;
          var sstkod = vm.stKodBit;
          if (bstkod == "") bstkod = "1";
          if (sstkod == "") sstkod = "1";

          const args = {
            token: Store.state.tokenId,
            ARANAN: vm.gelenfiltre,
            ILKKAYIT: "0",
            SONKAYIT: "1000000",
            BAKIYEVARMI: vm.bakiyesiOlanlar,
            SIPARISVARMI: vm.siparisiOlanlar,
            bstokkod: bstkod,
            sstokkod: sstkod,
          };
          soap.createClient(url, function (err, client) {
            client.INT_Ls_Stock(args, function (err, result) {
              if (result.INT_Ls_StockResult == "-1") {
                Store.dispatch("logout");
                //this.$store.dispatch('login', payload)
              }
              try {
                vm.veriler = JSON.parse(result.INT_Ls_StockResult);

                if (vm.veriler.response == "Ok") {
                  vm.rowData = JSON.parse(vm.veriler.jsonData);
                  vm.KAYITSAYISI = "1";
                  vm.toplamKayitSayisi = vm.rowData[0].KAYITSAYISI;
                } else {
                  vs.notify({
                    title: "Uyarı",
                    text: vm.veriler.message,
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "warning",
                    position: "top-center",
                  });
                }
              } catch (error) {
                vs.notify({
                  title: "Hata",
                  text: "Liste getirilirken hata oluştu.",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                  position: "top-center",
                });
              }
            });
          });
        }
      }
    },
    onFilterModified(e) {
      if (e.filterInstance.getModelFromUi() == null) {
        this.gelenfiltre = "";
      } else this.gelenfiltre = e.filterInstance.getModelFromUi().filter;
    },

    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onSelectionChanged(params) {
      // this.$store.commit("account/SATINALMA_TUR", this.tur);
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.stokList();
    },
    getNow() {
      const today = new Date();
      const date =
        today.getDate() +
        "." +
        (today.getMonth() + 1) +
        "." +
        today.getFullYear();

      const dateTime = date;
      return dateTime;
    },
    getLastTreeMonth() {
      var d = new Date();
      d.setMonth(d.getMonth() - 3);
      return d.toLocaleDateString();
    },
    stokList() {
      var sonkayitcurrentGelenPage = this.currentGelenPage - 1;

      var vm = this;
      var vs = this.$vs;
      vs.loading({
        background: "#0064fa",
        color: "#fff",
        container: "#button-with-loading-yeni",
        scale: 0.45,
      });
      const soap = require("soap");
      const url = state.sistemAddress;
      var bstkod = vm.stKodBas;
      var sstkod = vm.stKodBit;

      if (bstkod == "") bstkod = "1";
      if (sstkod == "") sstkod = "1";

      if (vm.arananDeger != "" || bstkod != "1" || sstkod != "1") {
        const args = {
          token: Store.state.tokenId,
          ARANAN: vm.arananDeger,
          ILKKAYIT: "0",
          SONKAYIT: "1000000",
          BAKIYEVARMI: vm.bakiyesiOlanlar,
          SIPARISVARMI: vm.siparisiOlanlar,
          bstokkod: bstkod,
          sstokkod: sstkod,
        };

        soap.createClient(url, function (err, client) {
          client.INT_Ls_Stock(args, function (err, result) {
            if (result.INT_Ls_StockResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            try {
              vm.veriler = JSON.parse(result.INT_Ls_StockResult);

              if (vm.veriler.response == "Ok") {
                vm.rowData = JSON.parse(vm.veriler.jsonData);
                vm.KAYITSAYISI = "1";
                vm.toplamKayitSayisi = vm.rowData[0].KAYITSAYISI;

                vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
              } else {
                vs.notify({
                  title: "Uyarı",
                  text: vm.veriler.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning",
                  position: "top-center",
                });
                vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
              }
            } catch (error) {
              vs.notify({
                title: "Hata",
                text: "Liste getirilirken hata oluştu.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
              vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
            }
          });
        });
      } else {
        const args = {
          token: Store.state.tokenId,
          ARANAN: "",
          ILKKAYIT: this.pageLength * sonkayitcurrentGelenPage,
          SONKAYIT: this.pageLength,
          SIPARISVARMI: vm.siparisiOlanlar,
          BAKIYEVARMI: vm.bakiyesiOlanlar,
          bstokkod: bstkod,
          sstokkod: sstkod,
        };
        soap.createClient(url, function (err, client) {
          client.INT_Ls_Stock(args, function (err, result) {
            if (result.INT_Ls_StockResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            try {
              vm.veriler = JSON.parse(result.INT_Ls_StockResult);

              if (vm.veriler.response == "Ok") {
                vm.rowData = JSON.parse(vm.veriler.jsonData);
                vm.KAYITSAYISI = vm.rowData[0].KAYITSAYISI;
                vm.toplamKayitSayisi = vm.rowData[0].KAYITSAYISI;

                vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
              } else {
                vs.notify({
                  title: "Uyarı",
                  text: vm.veriler.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning",
                  position: "top-center",
                });
                vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
              }
            } catch (error) {
              vs.notify({
                title: "Hata",
                text: "Liste getirilirken hata oluştu.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
              vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
            }
          });
        });
      }
    },
  },
  components: {
    ButtonPrimary,
    AgGridVue,
    StokDetayButon,
  },
  created() {
    this.localeText = this.$store.state.account.AG_GRID_LOCALE_EN;
    this.rowSelection = "single";
  },
  beforeMount() {
    this.columnDefs = [
      {
        width: 100,
        field: "",
        cellRendererFramework: "StokDetayButon",
      },
      {
        headerName: "Stok Kodu",
        field: "STOCKNO",
        sortable: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Stok Adı",
        sortable: true,
        field: "STOCKNAME",
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Kategori",
        field: "SPECCODE_ARACU",
        sortable: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agTextColumnFilter",
      },
      {
        headerName: "OEM Nolar",
        field: "OEMNOLAR",
        sortable: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Alternatif Nolar",
        field: "ALTERNATIFNOLAR",
        sortable: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Giriş Adedi",
        field: "QENTRY",
        sortable: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agNumberColumnFilter",
      },
      {
        headerName: "Çıkış Adedi",
        field: "QEXIT",
        sortable: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agNumberColumnFilter",
      },
      {
        headerName: "Kalan Adet",
        field: "QREM",
        sortable: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agNumberColumnFilter",
      },
    ];
  },
};
</script>
<style lang="scss">
table.vgt-table {
  font-size: small;
}
</style>
